export const MAINTENANCE_DASHBOARD_LAYOUT_LOADING_CHANGED =
  "MAINTENANCE_DASHBOARD_LAYOUT_LOADING_CHANGED";

export const createMaintenanceDashboardLayoutLoadingChangedAction = (
  loading: boolean
) => {
  return {
    type: MAINTENANCE_DASHBOARD_LAYOUT_LOADING_CHANGED,
    payload: loading,
  };
};
